import i18n from "i18next";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { ChatProvider } from "./components/chat/ChatContext";
import Navbar from "./components/layout/Navbar";
import SEO from "./components/SEO";
import { useLoading } from "./contexts/LoadingContext";
import Ads from "./pages/Ads";
import MyAds from "./pages/AdsMy";
import ChangePassword from "./pages/ChangePassword";
import CommentManagerPage from "./pages/CommentManager";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import MathZooPage from "./pages/MathZooPage";
import MessageBox from "./pages/Messages";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import RecipeZonePage from "./pages/RecipeZonePage";
import Register from "./pages/Register";
import SearchStudent from "./pages/SearchStudent";
import SearchTutor from "./pages/SearchTutor";
import Terms from "./pages/Terms";
import TutorCenterDetailPage from "./pages/TutorCenterDetailPage";
import TutorCenters from "./pages/TutorCenters";

const ProtectedRoute = ({ children }) => {
  const { user, token } = useSelector((state) => state.auth);
  // Check if the user is null or the token is null
  if (!user || !token) {
    return <Login />;
  }
  // If the user is not null and the token is not null, render the children
  return children;
};

function App() {
  const { loading } = useLoading();
  const location = useLocation();

  // Hide navbar on game pages
  const hideNavbar = location.pathname.startsWith("/math-zoo");

  return (
    <ChatProvider>
      <div>
        <main>
          <SEO lang={i18n.language} />
          {!hideNavbar && <Navbar />}
          {loading && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-20">
              <svg
                className="animate-spin h-12 w-12 text-orange-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              <span className="ml-4 text-orange-500 text-xl font-bold">
                Loading...
              </span>
            </div>
          )}
          <div className="flex flex-row">
            <Toaster
              position="center"
              containerStyle={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9998,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            />
            <div className="flex flex-row basis-full   ">
              <Routes>
                <Route exact path="/" element={<Home />} />
                <Route path="/searchStudent" element={<SearchStudent />} />
                <Route path="/searchTutor" element={<SearchTutor />} />
                <Route path="/tutorCenters" element={<TutorCenters />} />
                <Route
                  path="/tutorCenters/:id"
                  element={<TutorCenterDetailPage />}
                />
                <Route
                  path="/tutorCenters/:id/:slug"
                  element={<TutorCenterDetailPage />}
                />
                <Route path="/login" element={<Login />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ads"
                  element={
                    <ProtectedRoute>
                      <Ads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ads/:id"
                  element={
                    <ProtectedRoute>
                      <Ads />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/myAds"
                  element={
                    <ProtectedRoute>
                      <MyAds />
                    </ProtectedRoute>
                  }
                />
                <Route path="/register" element={<Register />} />
                <Route path="/comments" element={<CommentManagerPage />} />
                <Route path="/forget-password" element={<ForgotPassword />} />
                <Route
                  path="/changepassword"
                  element={
                    <ProtectedRoute>
                      <ChangePassword />
                    </ProtectedRoute>
                  }
                />

                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/messages" element={<MessageBox />} />
                <Route path="/math-zoo" element={<MathZooPage />} />
                <Route path="/recipes" element={<RecipeZonePage />} />
              </Routes>
            </div>
            {/* <div className="lg:basis-1/4  ">
              <Chat />
            </div> */}
          </div>
        </main>
      </div>
    </ChatProvider>
  );
}

export default App;
